export default {
  message: {
    welcome:'مرحبا بكم في Huayan Juzhu',
    search: 'بحث',
    placeHolder: 'يرجى إدخال الكلمات المفتاحية للبحث',
    quantity: 'الكمية',
    color: 'اللون',
    design: 'أساسيات التصميم',
    specifications: 'المواصفات',
    China: 'الصين',
    MinimumOrder: 'الحد الأدنى للطلب',
    squareMeter: 'متر مربع',
    thickness: 'السماكة',
    price: 'السعر',
    material: 'المادة',
    sendEmail: 'إرسال بريد إلكتروني',
    phoneCall: 'اتصال هاتفي',
    ProductDetails: 'تفاصيل المنتج',
    Ltd: 'شركة شوتشاو ستون إندستري المحدودة',
    name: 'وانغ نينغبو',
    Tel: 'هاتف',
    SalesManager: 'مدير المبيعات',
    ContactTheSupplier: 'الاتصال بالمورد',
    languageList: {
      item0: 'الصينية المبسطة',
      item1: 'الإنجليزية',
      item2: 'العربية',
      item3: 'الفيتنامية',
      // item4: 'الإندونيسية'
    },
    desc: 'من خلال إنترنت الصناعة، أنشأت شركة Huayan Juzhu نظام سلسلة توريد حجرية عالمية متكاملة، وأنشأت مصفوفة منتجاتها الخاصة، وحسنت التخطيط البيئي لأعلى وأسفل الصناعة. منذ تأسيسها في عام 2020، غطت ما يقرب من 20 متجرًا مركزيًا مقاطعات خنان وآنهوي وشاندونغ وهونان وخبي وبلديات تيانجين وبكين. يبلغ حجم المبيعات السنوية الرئيسية للحجر الصناعي 3.6 مليون متر مكعب، لتصبح أكبر مورد وموزع للحجر الصناعي محليًا، مع 3 مليون متر مكعب من الجرانيت، وأكثر من 500،000 متر مكعب من الكوارتز، وأكثر من 200،000 متر مكعب من الألواح الحجرية، لتصبح رائدة في الصناعة المحلية. من خلال الإنترنت، تقوم باستمرار بتحسين هيكل سلسلة التوريد لتقديم خدمة أفضل، وتحسين نموذج البيع بالتجزئة الحالي، واستخدام البيانات الضخمة والبرامج والأجهزة الذكية، لتجاوز تجربة تجارة الجملة الحجرية التقليدية.'
  }
}